import React from 'react';
import Hero from './Hero';
import OurPuttiesProducts from './OurPuttiesProducts';

const PaintSingleCategory = () => {
  return (
    <>
      <Hero />
      <OurPuttiesProducts />
    </>
  );
};

export default PaintSingleCategory;
